import type { PageInitInput, PageStreamInput } from '@/domains/seek/types';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PageRepository } from '@/domains/seek/services/page-repository';
import { PageApi } from '@/domains/seek/apis/page-api';
import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core';
import type { RequestConfig } from '@patsnap/common-ps-http';

@injectable()
export class PageRepositoryImpl implements PageRepository {
    constructor(
        @inject(PageApi) private pageApi: PageApi
    ) {
    }

    pageInit(data: PageInitInput) {
        return this.pageApi.pageInit(data);
    }

    getPageStream<T>(data: PageStreamInput) {
        return this.pageApi.getPageStream<T>(data);
    }

    stopPageStreamEvent(question_id: string) {
        return this.pageApi.stopPageStreamEvent(question_id);
    }

    request<T extends PatSnapCommonResponseData>(config: RequestConfig) {
        return this.pageApi.request<T>(config);
    }
}
